import {useShopperContentAsset} from '../../../hooks/use-shopper-content'
import {useContentSlot} from '../../../hooks/useScapiCustomApi'

export const TYPE_CONTENT_ASSET = 'contentAsset'
export const TYPE_CONTENT_SLOT = 'contentSlot'

/**
 * @param {string} cid - content id
 * @param {TYPE_CONTENT_SLOT|TYPE_CONTENT_SLOT} type - content type
 * @param {import("@tanstack/react-query").UseQueryOptions} [queryOptions] additional options for the query
 * @return {import("@tanstack/react-query").UseQueryResult} the query result
 * @see <a href="https://tanstack.com/query/latest/docs/react/reference/useQuery">TanStack Query `useQuery` reference</a> for more information about the return value.
 */
const useCmsContent = (cid, type = TYPE_CONTENT_ASSET, queryOptions) => {
    const contentSlotQuery = useContentSlot(
        {
            parameters: {slotId: cid}
        },
        {
            ...queryOptions,
            enabled: type === TYPE_CONTENT_SLOT && queryOptions?.enabled !== false
        }
    )

    const contentAssetQuery = useShopperContentAsset(
        {parameters: {cid, c_html: true}},
        {
            ...queryOptions,
            enabled:
                !!cid &&
                cid !== '-' &&
                queryOptions?.enabled !== false &&
                type === TYPE_CONTENT_ASSET
        }
    )

    switch (type) {
        case TYPE_CONTENT_ASSET:
            return contentAssetQuery
        case TYPE_CONTENT_SLOT:
            return contentSlotQuery
        default:
            throw new Error(`Unknown CMS content type: ${type}`)
    }
}

export default useCmsContent
